import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import Typewriter from "typewriter-effect";

const SideBanner = () => {
  return (
    <div className="banner-image">
      <div className="banner-text" style={{ marginLeft: "50px" }}>
        <Typography
          mb={3}
          className="title"
          component="h1"
          sx={{
            color: "white",
            fontSize: "35px",
            display: "inline-block",
            marginTop: "65vh",
          }}
        >
          Exclusive&nbsp;
          <span
            className="text-slider"
            style={{
              display: "inline-block",
              verticalAlign: "top",
              width: "280px",
              height: "100px",
              overflow: "hidden",
            }}
          >
            <Typewriter
              options={{
                strings: ["Jobs", "Career", "Learning"],
                autoStart: true,
                loop: true,
                delay: 75,
                deleteSpeed: 50,
              }}
            />
          </span>
          <br />
          <span className="focus">Platform For</span> Finance <br /> Professionals
        </Typography>

        <Box mt={0.5} mb={1} className="work-type" sx={{ color: "white" }}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography variant="body1" className="city">
              Find the perfect next job
            </Typography>
            <Typography variant="body1">•</Typography>
            <Typography variant="body1" className="city">
              Chart your future career journey
            </Typography>
            <Typography variant="body1">•</Typography>
            <Typography variant="body1" className="city">
              Achieve your pinnacle
            </Typography>
          </Stack>
        </Box>
      </div>
    </div>
  );
};

export default SideBanner;
